import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class EnvService {
  // API_URL1 = 'http://142.132.181.255:3000/';
  // API_URL = 'http://142.132.181.255:3000/';

  // API_URL1 = 'http://192.168.0.103:3000/';
  // API_URL = 'http://192.168.0.103:3000/';
  // API_URL2 = 'http://192.168.0.103:3003/';

  // API_URL1 = 'http://192.168.1.40:3000/';
  // API_URL = 'http://192.168.1.40:3000/';
  // API_URL2 = 'http://192.168.1.40:3003/';

  // API_URL1 = 'http://192.168.148.216:3000/';
  // API_URL = 'http://192.168.148.216:3000/';

  // API_URL2 = 'http://192.168.148.216:3003/';
  

  
  // API_URL1 = 'http://pranera.in:3000/';
  // API_URL = 'http://pranera.in:3000/';

  // API_URL2 = 'http://pranera.in:3003/';


  // API_URL3 = 'http://pranera.in:3020/';


  // API_URL01 = 'http://pranera.in:3020/';

  // production mobile
  //  API_URL2 = 'http://37.27.217.83:3003/';
  //  API_URL3 = 'http://138.199.145.198:3020/'
  // API_URL = 'http://37.27.217.83:3000/';
  // API_URL1 = 'http://37.27.217.83:3000/';
  // API_URL01 = 'http://138.199.145.198:3020/';
  // API_URL_LOCAL = 'http://138.199.145.198:3020/';

  // production browser
   API_URL2 = 'http://localhost:3003/';
   API_URL3 = 'http://localhost:3020/'
  API_URL = 'http://localhost:3000/';
  API_URL1 = 'http://localhost:3000/';
  API_URL01 = 'http://localhost:3020/';
  API_URL_LOCAL = 'http://localhost:3020/';

  // local 
  //  API_URL2 = 'http://172.16.18.69:3003/';
  //  API_URL3 = 'http://172.16.18.69:3020/';
  // API_URL = 'http://172.16.18.69:3000/';
  // API_URL1 = 'http://172.16.18.69:3000/';
  // API_URL01 = 'http://172.16.18.69:3020/';


  // API_URL1 = 'http://localhost:3000/';

  // API_URL = 'http://localhost:3000/';

   // API_URL2 = 'http://10.10.30.142:3003/';


   //  API_URL1 = 'http://10.10.30.142:3000/';
   //  API_URL = 'http://10.10.30.142:3000/';

  // API_URL1 = 'http://172.16.18.7:3000/';
  // API_URL = 'http://172.16.18.7:3000/';

  // API_URL1 = 'http://172.16.19.121:3000/';
  // API_URL = 'http://172.16.19.121:3000/';

  // API_URL1 = 'http://202.21.41.138:3000/';
  // API_URL = 'http://202.21.41.138:3000/';
  constructor() { }
}




